export const CustomizeMondayItemIcons = {
  integrationItem: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5557 16.7685V17.7685H4.63869V16.7685H15.5557ZM18.1944 14.1299V5.63866C18.1943 4.18138 17.013 3.00006 15.5557 3H4.63869C3.18144 3.00011 2.00012 4.18142 2.00001 5.63866V14.1299C2.00014 15.5871 3.18145 16.7684 4.63869 16.7685V17.7685L4.45119 17.7636C2.59058 17.6691 1.09897 16.1771 1.00488 14.3164L1 14.1299V5.63866C1.00012 3.62914 2.62915 2.00012 4.63869 2H15.5557L15.7432 2.00488C17.6657 2.10252 19.1943 3.69199 19.1944 5.63866V14.1299L19.1896 14.3164C19.0955 16.1771 17.6039 17.6691 15.7432 17.7636L15.5557 17.7685V16.7685C17.013 16.7685 18.1943 15.5871 18.1944 14.1299Z"
        fill="currentColor"
      />
      <path
        d="M15.0557 13.4932C15.3317 13.4933 15.5557 13.7171 15.5557 13.9932C15.5557 14.2692 15.3317 14.493 15.0557 14.4932L3.92578 14.4932C3.64964 14.4932 3.42578 14.2693 3.42578 13.9932C3.42578 13.717 3.64964 13.4932 3.92578 13.4932L15.0557 13.4932Z"
        fill="currentColor"
      />
      <path
        d="M12.7951 6.4797C13.0003 6.29531 13.3165 6.31187 13.5012 6.51681C13.6859 6.72206 13.6693 7.03911 13.4641 7.22384L9.42109 10.8625L9.08613 11.1633L6.72969 9.04317C6.52467 8.85856 6.50828 8.54235 6.69258 8.33712C6.87731 8.13186 7.19435 8.11528 7.39961 8.30001L9.08613 9.81759L12.7951 6.4797Z"
        fill="currentColor"
      />
    </svg>
  ),
  stickyNote: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="sidebar_StickyNoteicon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 3H4C3.44771 3 3 3.44772 3 4V16C3 16.5523 3.44772 17 4 17H11.1716C11.4368 17 11.6911 16.8946 11.8787 16.7071L16.7071 11.8787C16.8946 11.6911 17 11.4368 17 11.1716V4C17 3.44771 16.5523 3 16 3ZM4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H11.1716C11.702 18 12.2107 17.7893 12.5858 17.4142L17.4142 12.5858C17.7893 12.2107 18 11.702 18 11.1716V4C18 2.89543 17.1046 2 16 2H4Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 12C10.5 11.1716 11.1716 10.5 12 10.5H17V11.5H12C11.7239 11.5 11.5 11.7239 11.5 12V18H10.5V12Z"
        fill="currentColor"
      />
    </svg>
  ),
  circle: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z"
        fill="currentColor"
      />
    </svg>
  ),
  rect: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M17 3H3V17H17V3ZM2 2V18H18V2H2Z" fill="currentColor" />
    </svg>
  ),
  "rounded-rect": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3H6C4.34315 3 3 4.34315 3 6V14C3 15.6569 4.34315 17 6 17H14C15.6569 17 17 15.6569 17 14V6C17 4.34315 15.6569 3 14 3ZM6 2C3.79086 2 2 3.79086 2 6V14C2 16.2091 3.79086 18 6 18H14C16.2091 18 18 16.2091 18 14V6C18 3.79086 16.2091 2 14 2H6Z"
        fill="currentColor"
      />
    </svg>
  ),
  cloud: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.22381 5.87057C5.88173 4.67947 7.0761 4.09043 8.31652 4.00995C9.54307 3.93036 10.8585 4.33096 11.9442 5.12066C13.4777 4.68607 15.0601 5.05297 16.0995 5.91572C16.695 6.40998 17.1514 7.10401 17.2477 7.93832C17.3092 8.47112 17.2172 9.00401 16.9843 9.51342C17.7077 10.2145 18.1522 11.1512 17.9548 12.1336C17.6941 13.4315 16.4945 14.1081 14.9903 14.2293C13.9068 15.469 12.1663 16 10.5979 16C9.14222 16 7.53579 15.54 6.49423 14.4481C5.21534 14.7515 3.93363 14.1765 3.21508 13.3796C2.76182 12.8769 2.41396 12.1623 2.51963 11.3627C2.55742 11.0766 2.64871 10.8117 2.78548 10.5699C2.62659 10.425 2.48723 10.2621 2.37053 10.0812C1.96289 9.44964 1.90465 8.7085 2.13235 8.04025C2.52903 6.8761 3.6985 6.05596 5.22381 5.87057ZM3.44351 9.81606C2.34544 8.78698 3.33284 6.83083 5.89121 6.83083C6.67241 4.49734 9.79719 4.49734 11.7502 6.2479C14.1652 5.21658 16.8849 6.91737 16.1412 8.93709C16.0429 9.20401 15.8841 9.47651 15.6562 9.74901C15.9659 9.93408 16.2266 10.1485 16.4334 10.3783C17.5305 11.5973 17.1135 13.2492 14.4844 13.2492C12.922 15.5836 8.2348 15.5836 6.82865 13.2492C5.1482 14.2153 2.93302 12.4648 3.63396 11.1044C3.78023 10.8205 4.05347 10.5536 4.48506 10.3319C4.03194 10.2263 3.68662 10.0439 3.44351 9.81606Z"
        fill="currentColor"
      />
    </svg>
  ),
  triangle: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9282 16L10 4L3.0718 16H16.9282ZM10.866 3.5C10.4811 2.83333 9.51888 2.83333 9.13398 3.5L2.20578 15.5C1.82088 16.1667 2.302 17 3.0718 17H16.9282C17.698 17 18.1791 16.1667 17.7942 15.5L10.866 3.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  diamond: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5355 9.24974L10.7071 3.42131C10.3166 3.03078 9.68342 3.03078 9.29289 3.42131L3.46446 9.24974C3.07394 9.64026 3.07394 10.2734 3.46446 10.664L9.29289 16.4924C9.68342 16.8829 10.3166 16.8829 10.7071 16.4924L16.5355 10.664C16.9261 10.2734 16.9261 9.64026 16.5355 9.24974ZM11.4142 2.7142C10.6332 1.93315 9.36683 1.93315 8.58579 2.7142L2.75735 8.54263C1.9763 9.32368 1.97631 10.59 2.75735 11.3711L8.58579 17.1995C9.36683 17.9805 10.6332 17.9805 11.4142 17.1995L17.2426 11.3711C18.0237 10.59 18.0237 9.32368 17.2426 8.54263L11.4142 2.7142Z"
        fill="currentColor"
      />
    </svg>
  ),
  hexagon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 12.8407V7.1593C16 6.80038 15.8076 6.46899 15.496 6.29097L10.496 3.43496C10.1886 3.25939 9.81137 3.25939 9.50401 3.43496L4.50401 6.29097C4.19235 6.46899 4 6.80038 4 7.1593V12.8407C4 13.1996 4.19235 13.531 4.50401 13.709L9.50401 16.5651C9.81137 16.7406 10.1886 16.7406 10.496 16.5651L15.496 13.709C15.8076 13.531 16 13.1996 16 12.8407ZM17 12.8407C17 13.5585 16.6153 14.2213 15.992 14.5774L10.992 17.4334C10.3773 17.7845 9.62273 17.7845 9.00802 17.4334L4.00802 14.5774C3.3847 14.2213 3 13.5585 3 12.8407V7.1593C3 6.44146 3.3847 5.77868 4.00802 5.42264L9.00802 2.56663C9.62273 2.2155 10.3773 2.2155 10.992 2.56663L15.992 5.42264C16.6153 5.77868 17 6.44146 17 7.1593V12.8407Z"
        fill="currentColor"
      />
    </svg>
  ),
  trapezoid: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.01 5.5H5.98995C5.53763 5.5 5.14163 5.80362 5.02422 6.24044L3.1428 13.2404C2.97205 13.8757 3.45068 14.5 4.10853 14.5H15.8915C16.5493 14.5 17.0279 13.8757 16.8572 13.2404L14.9758 6.24044C14.8584 5.80362 14.4624 5.5 14.01 5.5ZM5.98995 4.5C5.08531 4.5 4.29331 5.10724 4.0585 5.98088L2.17708 12.9809C1.83557 14.2515 2.79283 15.5 4.10853 15.5H15.8915C17.2072 15.5 18.1644 14.2515 17.8229 12.9809L15.9415 5.98087C15.7067 5.10724 14.9147 4.5 14.01 4.5H5.98995Z"
        fill="currentColor"
      />
    </svg>
  ),
  "square-callout": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49653 14.9484H15C16.1046 14.9484 17 14.053 17 12.9484V6.5C17 5.39543 16.1046 4.5 15 4.5H5C3.89543 4.5 3 5.39543 3 6.5V12.9484C3 14.053 3.89543 14.9484 5 14.9484H6.31077V16.537L8.49653 14.9484ZM8.82154 15.9484H15C16.6569 15.9484 18 14.6053 18 12.9484V6.5C18 4.84315 16.6569 3.5 15 3.5H5C3.34315 3.5 2 4.84315 2 6.5V12.9484C2 14.6053 3.34315 15.9484 5 15.9484H5.31077V17.5185C5.31077 17.9271 5.77423 18.1632 6.10473 17.923L8.82154 15.9484Z"
        fill="currentColor"
      />
    </svg>
  ),
  octagon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6483 3H6.35168C6.08647 3 5.83211 3.10536 5.64458 3.29289L3.29289 5.64458C3.10536 5.83211 3 6.08647 3 6.35168V13.6483C3 13.9135 3.10536 14.1679 3.29289 14.3554L5.64458 16.7071C5.83211 16.8946 6.08647 17 6.35168 17H13.6483C13.9135 17 14.1679 16.8946 14.3554 16.7071L16.7071 14.3554C16.8946 14.1679 17 13.9135 17 13.6483V6.35168C17 6.08647 16.8946 5.83211 16.7071 5.64458L14.3554 3.29289C14.1679 3.10536 13.9135 3 13.6483 3ZM13.6483 2C14.1787 2 14.6875 2.21071 15.0625 2.58579L17.4142 4.93747C17.7893 5.31254 18 5.82125 18 6.35168V13.6483C18 14.1787 17.7893 14.6875 17.4142 15.0625L15.0625 17.4142C14.6875 17.7893 14.1787 18 13.6483 18H6.35168C5.82125 18 5.31254 17.7893 4.93747 17.4142L2.58579 15.0625C2.21071 14.6875 2 14.1787 2 13.6483V6.35168C2 5.82125 2.21071 5.31254 2.58579 4.93747L4.93747 2.58579C5.31254 2.21071 5.82125 2 6.35168 2H13.6483Z"
        fill="currentColor"
      />
    </svg>
  ),
  "fat-arrow-right": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9417 6.00002H4C3.44771 6.00002 3 6.44773 3 7.00002V13.19C3 13.7423 3.44772 14.19 4 14.19H11.9417V16.7752L17.6887 10L11.9417 3.22484V6.00002ZM11.4129 17.3986C11.4128 17.3988 11.4131 17.3984 11.4129 17.3986V17.3986ZM10.9417 2.40739C10.9417 1.75572 11.754 1.45762 12.1756 1.95459L18.7257 9.67658C18.8839 9.86316 18.8839 10.1369 18.7257 10.3235L12.1756 18.0455C11.754 18.5424 10.9417 18.2443 10.9417 17.5926V15.19H4C2.89543 15.19 2 14.2946 2 13.19V7.00002C2 5.89545 2.89543 5.00002 4 5.00002H10.9417V2.40739Z"
        fill="currentColor"
      />
    </svg>
  ),
  "fat-arrow-left": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.05827 14L17 14C17.5523 14 18 13.5523 18 13L18 6.80998C18 6.2577 17.5523 5.80998 17 5.80998L9.05827 5.80998L9.05827 3.2248L3.3113 9.99998L9.05827 16.7752L9.05827 14ZM9.58705 2.60142C9.5872 2.60124 9.5869 2.60159 9.58705 2.60142V2.60142ZM10.0583 17.5926C10.0583 18.2443 9.24599 18.5424 8.82445 18.0454L2.27435 10.3234C2.11608 10.1368 2.11608 9.86313 2.27435 9.67655L8.82445 1.95455C9.246 1.45758 10.0583 1.75569 10.0583 2.40736L10.0583 4.80998L17 4.80998C18.1046 4.80998 19 5.70541 19 6.80998L19 13C19 14.1046 18.1046 15 17 15L10.0583 15L10.0583 17.5926Z"
        fill="currentColor"
      />
    </svg>
  ),
  "flipped-trapezoid": (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.98996 14.5L14.01 14.5C14.4624 14.5 14.8584 14.1964 14.9758 13.7596L16.8572 6.75956C17.028 6.12426 16.5493 5.5 15.8915 5.5L4.10853 5.5C3.45069 5.5 2.97205 6.12426 3.14281 6.75956L5.02423 13.7596C5.14163 14.1964 5.53764 14.5 5.98996 14.5ZM14.01 15.5C14.9147 15.5 15.7067 14.8928 15.9415 14.0191L17.8229 7.01913C18.1644 5.74853 17.2072 4.5 15.8915 4.5L4.10853 4.5C2.79284 4.5 1.83558 5.74853 2.17708 7.01913L4.0585 14.0191C4.29331 14.8928 5.08532 15.5 5.98996 15.5L14.01 15.5Z"
        fill="currentColor"
      />
    </svg>
  ),
};
